import React from 'react';

interface ArrowIconProps {
  className?: string;
  size?: number;
}

export const ArrowIcon: React.FC<ArrowIconProps> = ({ 
  className = "w-5 h-5", 
  size = 20 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      {/* Arrow shaft with natural curve */}
      <path
        d="M5 12h14"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Arrow head with organic shape */}
      <path
        d="M12 5l7 7-7 7"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Subtle arrow shadow */}
      <path
        d="M5 12h14"
        stroke="currentColor"
        strokeWidth="0.5"
        opacity="0.3"
        strokeDasharray="1 1"
      />
    </svg>
  );
};

export default ArrowIcon;
